import React, { Component } from 'react';
import FieldSelect from '../field-select';

import type { IBaseFieldProps } from 'bz-core-controls/controls/form/field/generics/IBaseFieldProps';

interface IProps extends IBaseFieldProps {
  items: [];
  lookup: string;
  displayMember: string;
  fullWidth: boolean;
  dataTestId: string;
  placeholder: string;
  maxLength: number;
}

export default class FieldCombobox extends Component<IProps> {
  render() {
    return <FieldSelect filterable dynamic {...this.props} dataTestId={this.props.dataTestId} />;
  }
}
